import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { Fec } from '@shared/interfaces/fec';
import { FecFilter } from '@shared/interfaces/fecFilter';
import { EpochDateTimePipe } from '@shared/pipes/epoch-datetime.pipe';
import { LoadingProvider } from '@shared/providers/loading.provider';
import { FecService } from '@shared/services/fec.service';
import { saveTextFile } from '@shared/util/fileUtil';
import { arrayIsEmpty } from '@shared/util/listUtil';
import { isNotBlank } from '@shared/util/stringUtils';
import { JsonEditorOptions, NgJsonEditorModule } from 'ang-jsoneditor';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { FecApprovalDetailComponent } from '../fec-approval-detail/fec-approval-detail.component';

@Component({
  selector: 'app-fec-admin',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    NgxMaskDirective, 
    NgxMaskPipe,
    ToastModule,
    ButtonComponent,
    ModalComponent,
    NgJsonEditorModule,
    EpochDateTimePipe,
    FecApprovalDetailComponent
  ],
  providers: [provideNgxMask(), MessageService],
  templateUrl: './fec-admin.component.html',
  styleUrl: './fec-admin.component.scss'
})
export class FecAdminComponent {
  @ViewChild('viewModal') viewModal!: ModalComponent; 
  @ViewChild('approvalModal') approvalModal!: ModalComponent; 
  public editorOptions: JsonEditorOptions;
  selected: Fec[] = [];
  records: Fec[] = [];
  recordSelected: Fec = {};
  statusList = ["draft", "registered"];
  recordStatusList = ["active", "disabled", "deleted"];
  totalRecords: number = 0;
  loading: boolean = false;
  public form: FormGroup = this.fb.group({
    rut: [''],
    clientName: [''],
    clientStatus: [''],
    recordStatus: ['active'],
  });

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private fb: FormBuilder, 
    private messageService: MessageService,
    private loadingProvider: LoadingProvider,
    private fecService: FecService) {
      this.editorOptions = new JsonEditorOptions()
      this.editorOptions.modes = ['code', 'text', 'tree', 'view']; // set all allowed modes
      this.editorOptions.mode = 'code'; //set only one mode
  }

  onSearch(params: TableLazyLoadEvent){
    this.loading = true;
    this.fecService.pagedFindFec({
      filters: this.form.value as FecFilter,
      first: params.first ?? 0,
      rows: params.rows ?? 10
    }).subscribe((resp) => {
      this.records = resp.list;
      this.totalRecords = resp.total;
      this.loading = false;
      this.selected = [];
    });
  }

  deleteBase(filter: FecFilter){
    this.loadingProvider.show();
    this.fecService.deleteByGenerator(filter).subscribe({
      next: (resp) => {
        let ids = isNotBlank(filter.id) ? filter.id : filter.ids?.join(',');
        this.loadingProvider.hide();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `eliminado(s) ${ids}` });
        this.selected = [];
        this.onSearch({});
      },
      error: (err) => {
        this.loadingProvider.hide();
        let msg = err.error?.message || 'Ocurrió un error';
        console.log(msg);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
      }
    });
  }

  deleteSelected(){
    if (!arrayIsEmpty(this.selected)){
      let ids: string[] = this.selected.map(item => item.id!);
      this.deleteBase({
        ids
      });
    }
  }

  delete(fec: Fec){
    this.deleteBase({
      id: fec.id
    });
  }

  view(fec: Fec){
    this.recordSelected = fec;
    this.viewModal.openModal();
  }

  viewApproval(fec: Fec){
    this.recordSelected = fec;
    this.approvalModal.openModal();
  }

  download(fec: Fec){
    saveTextFile(JSON.stringify(fec, null, 2), `${fec.id}.json`);
  }
}
